import React from "react"
import { Link } from "gatsby";
// import { Link } from "gatsby"

// import { rhythm, scale } from "../utils/typography"

class Layout extends React.Component {
  render() {
    const { children } = this.props
    // const rootPath = `${__PATH_PREFIX__}/`
    // let header

    // if (location.pathname === rootPath) {
    //   header = (
    //     <h1
    //       style={{
    //         ...scale(1.5),
    //         marginBottom: rhythm(1.5),
    //         marginTop: 0,
    //       }}
    //     >
    //       <Link
    //         style={{
    //           boxShadow: `none`,
    //           textDecoration: `none`,
    //           color: `inherit`,
    //         }}
    //         to={`/`}
    //       >
    //         {title}
    //       </Link>
    //     </h1>
    //   )
    // } else {
    //   header = (
    //     <h3
    //       style={{
    //         fontFamily: `Montserrat, sans-serif`,
    //         marginTop: 0,
    //       }}
    //     >
    //       <Link
    //         style={{
    //           boxShadow: `none`,
    //           textDecoration: `none`,
    //           color: `inherit`,
    //         }}
    //         to={`/`}
    //       >
    //         {title}
    //       </Link>
    //     </h3>
    //   )
    // }
    return (
      <section class="hero is-link" id="menu-bar">
        <div class="hero-head">
          <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
            
              <span class="navbar-item is-size-4 has-text-weight-semibold has-text-white">
                <figure class="image is-24x24 is-inline-block" style={{"margin-bottom": "0px"}}>
                  <img class="is-rounded" alt="" src="/icons/icon-48x48.png"/>
                </figure>&nbsp;
                <Link style={{
                  boxShadow: `none`,
                  textDecoration: `none`,
                  color: `inherit`,}}
                  to={'/'}>
                  Penang Rider - Blog
                </Link>
              </span>
            </div>
    
          </nav>
          </div>
          <div class="hero-body">
        <div class="container">{children}</div>
        
      {/* </div> */}
          </div>
          <div class="hero-foot">
            <div class="content has-text-centered">
              © {new Date().getFullYear()}, Built with Gatsby
            </div>
        </div>
        </section>
      
    )
  }
}

export default Layout
